export default __webpack_public_path__ + "static/media/vomozflex-orange.bd98c46e.svg";